<template>
    <div>
        <label v-if="label" :for="id" class="block text-xs  text-gray-500 pt-2">{{label}}</label>
        
        <div v-if="detail" 
          class="block text-xs font-medium text-gray-400 pt-1 pb-1"
          :class="{'underline': detailUrl }"
          >
          <a :href="detailUrl">{{detail}}</a>
        </div>
        <div class="mt-1 relative rounded-md shadow-sm flex">
          
          <div v-if="pre" class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="text-gray-500 sm:text-sm z-20">
              {{pre}}
            </span>
          </div>

          <input readonly="true"
            class="focus-within:z-10 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full border-gray-300 rounded-md text-xs h-8 pl-2"
            :class="{'pl-16 sm:pl-14': pre}" 
            :value="modelValue">
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    name: 'CustomInput',
    components: {
    },
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      }
    },
    props: [
        'id',
        'label',
        'detail',
        'detailUrl',
        'type',
        'placeholder',
        'modelValue',
        'pre',
    ]
};
</script>